import type { CustomChartPoint } from '@/entities/dashboards';

/** Доля круговой диаграммы: точка данных и её доля в целом (0..1). */
export type PieSlice = {
  label: string;
  value: number;
  share: number;
};

/**
 * Доли круговой диаграммы по точкам данных.
 *
 * Доли считаются от суммы положительных значений: отрицательная величина доли не образует,
 * и такой набор остаётся пустым — показывать его искажённым кругом нельзя.
 */
export const toPieSlices = (points: CustomChartPoint[]): PieSlice[] => {
  const positive = points.filter((point): point is CustomChartPoint & { value: number } => (point.value ?? 0) > 0);
  const total = positive.reduce((sum, point) => sum + point.value, 0);
  if (total <= 0) return [];
  return positive.map((point) => ({ label: point.label, value: point.value, share: point.value / total }));
};
